'use client'

import { FunctionComponent, useState } from 'react'
import classNames from 'classnames'
import CouponInput from './CouponInput'
import styles from './CouponContainer.module.css'
import { Button } from '@/app/_components/Button'
import TXT from '@/messages'

const CouponContainer: FunctionComponent = () => {
  const [open, setOpen] = useState(false)
  return (
    <div className={styles.OuterContainer}>
      {open
        ? <CouponInput />
        : (
          <Button
            className={classNames(styles.SingleInputToggle, 'btn-override')}
            variant="outline"
            data-testid="apply-coupon"
            size="sm"
            onClick={() => setOpen(!open)}
            weight="bold"
          >
            {TXT.buttons.applyCoupon}
          </Button>
        )}
    </div>
  )
}

export default CouponContainer
